import { BaseObject } from "../core/BaseObject";

export class ServiceCategoryItem extends BaseObject {
	id: number;
	name: string;
	sla: number;
	serviceModeId: number;
	minDistance: number;
	maxDistance: number;
	/**
	* Коэффициент стоимости SLA
	**/
	standartHourPrice: number;
}
